module.exports = __webpack_public_path__ + "static/media/DK4055_01.fb608b83.jpg";